import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import styles from './styles';

class AppHeader extends React.Component {
  render() {
    const {
      classes: { titleText },
    } = this.props;
    const title = this.props.title || "Current / Today's weather for Plano, TX";
    return <div className={titleText}>{title}</div>;
  }
}

AppHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(AppHeader));
